```vue
<template>
  <b-modal
      :title="isUpdating ? 'ویرایش بج' : 'ایجاد بج جدید'"
      id="modal-badge-create-update"
      centered
      :ok-title="isUpdating ? 'ویرایش' : 'ایجاد'"
      cancel-title="انصراف"
      @ok.prevent="decideAction"
      @hidden="closeModal"
  >
    <b-container fluid>
      <b-form-row @submit.prevent>
        <b-col cols="12">
          <b-form-group label="نام بج" label-for="title">
            <b-form-input
                size="sm"
                id="title"
                v-model="badgeDetails.title"
                placeholder="طلایی"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label="اولویت" label-for="order">
            <b-form-input
                type="number"
                size="sm"
                id="order"
                v-model.number="badgeDetails.order"
                placeholder="5"
                min="0"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label="مهلت استفاده از تخفیف" label-for="dayToDown">
            <b-input-group size="sm" append="روز">
              <b-form-input
                  id="dayToDown"
                  v-model.number="badgeDetails.dayToDown"
                  type="number"
                  min="0"
                  placeholder="مثلاً 30"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label="مقدار تخفیف به درصد (%)" label-for="percent">
            <b-input-group size="sm" append="%">
              <b-form-input
                  v-model.number="badgeDetails.percent"
                  id="percent"
                  trim
                  type="number"
                  placeholder="3"
                  min="0"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label="رنگ برچسب کاربر در این تخفیف" label-for="colorCode">
            <b-input-group size="sm" :append="badgeDetails.colorCode">
              <b-form-input
                  v-model="badgeDetails.colorCode"
                  id="colorCode"
                  trim
                  type="color"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label="عکس بج" label-for="imageFile">
            <b-form-file
                size="sm"
                ref="imageFile"
                id="imageFile"
                v-model="badgeDetails.formFile"
                accept=".jpg,.jpeg,.png"
                @input="handleImageFile"
            />
          </b-form-group>
        </b-col>

        <b-col cols="6" v-if="badgeDetails.imageUrl">
          <small>عکس فعلی</small>
          <img
              style="width: auto; height: 8rem; object-fit: contain"
              :src="`${baseUrl}/${badgeDetails.imageUrl}`"
              alt=""
          />
        </b-col>

        <b-col cols="6" v-if="imagePreview">
          <div class="d-flex flex-column align-items-center justify-content-center">
            <small>پیشنمایش</small>
            <b-button
                @click="resetFormFile"
                type="button"
                variant="transparent"
                size="sm"
                class="mb-0"
            >
              <feather-icon icon="Trash2Icon" size="20" class="text-danger" />
            </b-button>
            <img
                style="width: auto; height: 8rem; object-fit: contain"
                :src="imagePreview"
                alt=""
            />
          </div>
        </b-col>
      </b-form-row>
    </b-container>
  </b-modal>
</template>

<script>
import {
  BModal,
  BContainer,
  BRow,
  BCol,
  BFormRow,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BFormFile,
  BButton,
} from "bootstrap-vue";
import {
  UpdateASingleScheduleLoyaltyDiscountTitle,
  CreateNewScheduleLoyaltyTitle,
} from "@/libs/Api/ScheduleLoyaltyDiscountTitle";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  emits: ["closeCreateUpdateModal", "loading", "loaded", "fetchData"],
  props: {
    isUpdating: {
      type: Boolean,
      required: false,
      default: false,
    },
    badgeUpdateDetails: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      badgeDetails: {
        id: null,
        title: null,
        order: null,
        dayToDown: null,
        percent: null,
        colorCode: "#ffffff",
        formFile: null,
        imageUrl: null,
      },
      imagePreview: null,
    };
  },
  mounted() {
    if (this.badgeUpdateDetails) {
      const cloned = JSON.parse(JSON.stringify(this.badgeUpdateDetails));
      this.badgeDetails = {
        ...this.badgeDetails,
        ...cloned,
        dayToDown: cloned.dayToDown ?? cloned.DayToDown ?? null,
      };
    }
  },
  computed: {
    baseUrl() {
      return process.env.VUE_APP_BASE_URL;
    },
  },
  methods: {
    handleImageFile() {
      if (this.badgeDetails.formFile) {
        if (this.imagePreview) URL.revokeObjectURL(this.imagePreview);
        this.imagePreview = URL.createObjectURL(this.badgeDetails.formFile);
      }
    },
    resetFormFile() {
      const old = this.imagePreview;
      this.imagePreview = null;
      if (old) URL.revokeObjectURL(old);
      if (this.$refs.imageFile) this.$refs.imageFile.value = "";
      this.badgeDetails.formFile = null;
    },
    decideAction() {
      if (this.isUpdating) this.updateABadge();
      else this.createABadge();
    },
    buildFormData() {
      const fd = new FormData();
      fd.append("id", this.badgeDetails.id ?? "");
      fd.append("title", this.badgeDetails.title ?? "");
      fd.append("order", this.badgeDetails.order ?? "");
      fd.append("percent", this.badgeDetails.percent ?? "");
      fd.append("colorCode", this.badgeDetails.colorCode ?? "#ffffff");
      fd.append("DayToDown", this.badgeDetails.dayToDown ?? "");
      if (this.badgeDetails.formFile) fd.append("formFile", this.badgeDetails.formFile);
      return fd;
    },
    async updateABadge() {
      const myFormData = this.buildFormData();
      try {
        this.$emit("loading");
        const _this = this;
        const api = new UpdateASingleScheduleLoyaltyDiscountTitle(_this);
        api.setFormData(myFormData);
        await api.sendFormData((res) => {
          if (res.data?.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "بج با موفقیت ویرایش شد.",
              },
            });
            _this.$emit("fetchData");
            _this.$emit("loaded", true);
            _this.closeModal();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.data?.errors || "لطفا دوباره تلاش کنید",
              },
            });
            _this.$emit("loaded", false);
          }
        });
      } catch (error) {
        console.error(error);
        this.$emit("loaded", false);
      }
    },
    async createABadge() {
      const myFormData = this.buildFormData();
      try {
        this.$emit("loading");
        const _this = this;
        const api = new CreateNewScheduleLoyaltyTitle(_this);
        api.setFormData(myFormData);
        await api.sendFormData((res) => {
          if (res.data?.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ثبت شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "بج با موفقیت ایجاد شد.",
              },
            });
            _this.$emit("fetchData");
            _this.$emit("loaded", true);
            _this.closeModal();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.data?.errors || "لطفا دوباره تلاش کنید",
              },
            });
            _this.$emit("loaded", false);
          }
        });
      } catch (error) {
        console.error(error);
        this.$emit("loaded", false);
      }
    },
    closeModal() {
      this.resetFormFile();
      this.$emit("closeCreateUpdateModal");
    },
  },
  components: {
    BModal,
    BContainer,
    BRow,
    BCol,
    BFormRow,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormFile,
    BButton,
  },
};
</script>